import styled from 'styled-components';

export const StyledStartButton = styled.div`
  box-sizing: border-box;
  margin: 0 0 20px 0;
  padding: 40px;
  min-height: 40px;
  width: 100%;
  border-radius: 20px;
  border: none;
  outline: none;
  color: white;
  background: #333;
  font-size: 24px;
  cursor: pointer;
`;